import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  ButtonGroup,
  Input,
  Label,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {
  getLocalStorageData,
  displayDateV1,
  convertDateFormate,
  getDateByName,
  getPercentageWithAlertV1,
  currencyFormatWithoutDecimalV1,
} from "../../helpers/api_helper";
import ReactApexChart from "react-apexcharts";

const CaptureRateMealPeriod = ({ captureRateByMeal, loading }) => {
  // const [categories, setCategories] = useState(["Breakfast", "Lunch", "Dinner"]);
  // const [seriesData, setSeriesData] = useState([80, 30, 50]);
  const categories = Object.keys(captureRateByMeal); // ["Breakfast", "Lunch", ...]
  const cateVal = Object.values(captureRateByMeal);
  const seriesData = cateVal.map((v) => parseFloat(v.toFixed(2)));

  // Get min and max from rounded values
  const min = Math.min(...seriesData);
  const max = Math.max(...seriesData);

  const buffer = (max - min) * 0.1;

  const roundedMin = Math.max(0, Math.floor(min - buffer));
  const roundedMax = Math.ceil(max + buffer);
  let YAXIS_MAX = 15;
  if (roundedMax > 15) {
    YAXIS_MAX = roundedMax;
  }

  const options = {
    chart: {
      type: "line",
      zoom: { enabled: true },
      toolbar: { show: true },
    },
    stroke: {
      curve: "smooth", // rounded/smooth line
      width: 2,
    },
    xaxis: {
      categories: categories,
      labels: {
        formatter: (val) => `${val}`,
        style: { fontSize: "14px", fill: "#000" },
      },
    },
    yaxis: {
      min: 0,
      max: YAXIS_MAX,
      tickAmount: 5,
      labels: {
        formatter: (val) => `${Math.round(val)}%`,
        style: { fontSize: "14px", fill: "#000" },
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#3b76e1"], // line color
    markers: {
      size: 3,
      strokeWidth: 2,
      strokeColors: "#3b76e1",
      hover: { size: 5 },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${val.toFixed(2)}`,
      },
    },
  };

  const series = [
    {
      name: "Capture Rate",
      data: seriesData,
    },
  ];

  return (

    <Col sm={12} lg={12}>
      <Card className="px-3" style={{ minHeight: "470px" }}>
        <CardHeader className="ps-0 border-0 align-items-center">
          <div className="d-flex align-items-start">
            <div className={`icon-box rounded bg-danger text-white`}>
              <i className="ri-line-chart-fill"></i>
            </div>
            <div className="ps-2">
              <h4 className="card-title mb-0 flex-grow-1">
                Capture Rate by Meal Period
              </h4>
              <p>
                Percentage of hotel guests who dined at the restaurant during each
                meal service
              </p></div>
          </div>
        </CardHeader>
        <CardBody className="p-0">
          {loading && <Loader />}
          <div className={loading ? "opacity-0" : ""}>
            <ReactApexChart
              options={options}
              series={series}
              type="line"
              height={350}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CaptureRateMealPeriod;
